import { getAPICallFeature } from '@micro-frontend-react/employee-experience/lib/UsageTelemetryHelper';
import { CustomProperties, IHttpClient } from '@employee-experience/common/lib/Models';
import { SagaIterator } from 'redux-saga';
import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';
import { IRequestUserProfileAction, UserActionTypes } from '../action-types/userProfileActionTypes';
import { receiveUserProfile, receiveUserProfileFailed } from '../actions/userProfileActions';

export function getSharedHttpConfig(url: string): CustomProperties {
  const resource = __EVL_API_RESOURCE_ID__;

  const httpConfig: CustomProperties = {
    url,
    resource,
  };

  return httpConfig;
}

export function* fetchUserProfile(action: IRequestUserProfileAction): SagaIterator {
  const { feature } = action;
  const httpClient: IHttpClient = yield getContext('httpClient');

  try {
    const response = yield call(
      [httpClient, httpClient.request],
      getSharedHttpConfig(`${__EVL_API_BASE_URL__}api/v1.0/permissions`),
      {},
      getAPICallFeature({ feature: 'EVL', subFeature: 'Home' }, 'fetchUserProfile')
    );
    yield put(receiveUserProfile(response.data));
  } catch (exs) {
    yield put(receiveUserProfileFailed('something failed'));
  }
}

export function* userProfileSagas(): SagaIterator {
  yield all([takeLatest(UserActionTypes.REQUEST_USERPROFILE, fetchUserProfile)]);
}
